import { HitData } from 'common/store/common/search/types';
import { AppSpecifiedSearchHitService } from 'common/services/search/commonSearchHitService';
import { isNullOrUndefined } from 'common/util/utils';
import {
    ASSESSMENTRUN_INDEX,
    ASSESSMENTRUNQUESTION_INDEX,
    CANDIDATE_INDEX,
    GRADING_PARTY_INDEX,
    USERQUESTION_INDEX,
} from '../../store/common/search/constants';
import { ContextState } from '../../store/context/reducer';
import store from '../../store';
import { RootState } from '../../store/rootReducer';

const searchHitService: AppSpecifiedSearchHitService = {
    getFooterOption(hit: HitData, dataType: string) {
        switch (dataType) {
        case CANDIDATE_INDEX:
            return {
                key: hit.userId,
                text: hit.candidateId,
                value: hit.userId,
            };
        case GRADING_PARTY_INDEX:
            return {
                key: hit.partyId,
                text: hit.partyName,
                value: hit.partyId,
            };
        case USERQUESTION_INDEX:
            return {
                key: hit.questionId,
                text: hit.questionNumbering,
                value: hit.questionId,
            };
        }
        return undefined;
    },
    getHitSelectionValue(context: ContextState, dataType: string) {
        switch (dataType) {
        case CANDIDATE_INDEX:
        case GRADING_PARTY_INDEX:
            return context.partyId;
        case USERQUESTION_INDEX:
            return context.questionId;
        }
        return undefined;
    },
    getHitSelectionKey(dataType: string): string {
        switch (dataType) {
        case CANDIDATE_INDEX:
            return 'userId';
        case GRADING_PARTY_INDEX:
            return 'partyId';
        case USERQUESTION_INDEX:
            return 'questionId';
        case ASSESSMENTRUNQUESTION_INDEX:
            return 'assessmentRunQuestionId';
        case ASSESSMENTRUN_INDEX:
            return 'objectId';
        }
        return undefined;
    },
    getHitPrimaryIdValue(hitData: HitData, dataType: string) {
        switch (dataType) {
        case CANDIDATE_INDEX:
            return hitData.userId;
        case GRADING_PARTY_INDEX:
            return hitData.partyId;
        case USERQUESTION_INDEX:
            return hitData.questionId;
        case ASSESSMENTRUNQUESTION_INDEX:
            return hitData.assessmentRunQuestionId;
        case ASSESSMENTRUN_INDEX:
            return hitData.objectId;
        }
        return undefined;
    },
    getHitAssessmentRunId(hitData: HitData) {
        return hitData.assessmentRunId;
    },
    getHitUniqueIdValue(hitData: HitData, dataType: string) {
        if (dataType === GRADING_PARTY_INDEX) {
            return `${this.getHitPrimaryIdValue(hitData, dataType)}_${this.getHitAssessmentRunId(hitData)}`;
        }
        return this.getHitPrimaryIdValue(hitData, dataType);
    },
    getHitPrimaryNameValue(hitData: HitData, dataType: string) {
        switch (dataType) {
        case CANDIDATE_INDEX:
            return hitData.candidateId;
        case GRADING_PARTY_INDEX:
            return hitData.partyName;
        case USERQUESTION_INDEX:
        case ASSESSMENTRUNQUESTION_INDEX:
            return hitData.questionNumbering;
        case ASSESSMENTRUN_INDEX:
            return hitData.title;
        }
        return undefined;
    },

    isActiveHit(hitData: HitData, context: ContextState, dataType: string): boolean {
        switch (dataType) {
        case CANDIDATE_INDEX:
            return hitData.objectId === context.s;
        case GRADING_PARTY_INDEX:
            return hitData.partyId === context.partyId;
        case USERQUESTION_INDEX:
            return hitData.questionId === context.questionId;
        }
        return false;
    },

    hasAccessToActions(dataType: string): boolean {
        return dataType === GRADING_PARTY_INDEX || dataType === ASSESSMENTRUNQUESTION_INDEX;
    },

    getAlternativeUserIdIfExists(): number {
        return (store.getState() as RootState).assessment.collaborativeEvaluatorId;
    },

    getQuestionWeight(hitData: HitData): number {
        const { questionWeight } = hitData;

        return !isNullOrUndefined(questionWeight) ? questionWeight : 1;
    },
};

export default searchHitService;
